import { LayoutInfo, LayoutProps } from '../types'
import { defaultClipScene } from '../types/defaultClipScene'
import VideoLayout from './VideoLayout'

function TranslucentLayout({ children, ...props }: LayoutProps) {
  return (
    <VideoLayout {...props}>
      <div className="rounded-3xl bg-black/40 p-5">{children}</div>
    </VideoLayout>
  )
}

export const translucentLayoutInfo: LayoutInfo = {
  name: 'translucent',
  Component: TranslucentLayout,
  defaultScene: {
    ...defaultClipScene,
    duration: 6,
    layout: 'translucent',
    mediaUrl:
      'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/1080/Big_Buck_Bunny_1080_10s_1MB.mp4',
    paragraphs: [{ start: 2.32, end: 5.7, speaker: { username: 'petrbela' } }],
    words: [
      { end: 2.82, start: 2.32, text: 'Okay.' },
      { end: 3.2, start: 2.88, text: "There's" },
      { end: 3.36, start: 3.2, text: 'a' },
      { end: 3.86, start: 3.36, text: 'test.' },
      { end: 5.2, start: 4.72, text: "Let's" },
      { end: 5.7, start: 5.2, text: 'see.' },
    ],
  },
  defaultStyle: {
    background: { color: 'primary' },
    border: { color: 'secondary' },
    logo: { color: 'secondary' },
    waveform: { color: 'accent' },
    transcription: {
      color: 'white',
      fontFamily: 'primary',
      highlightColor: 'accent',
      unPlayedColor: 'white',
      unPlayedOpacity: 1,
      highlightType: 'last-word',
      fontSize: 60,
      scrollType: 'line-by-line',
      fontWeight: 500,
      linesPerPage: 1,
      lineHeight: 1.5,
      textAlign: 'center',
    },
    title: {
      color: 'secondary',
      fontFamily: 'primary',
    },
    subtitle: {
      color: 'secondary',
      fontFamily: 'primary',
      opacity: 0.5,
    },
    speakerName: {
      color: 'secondary',
      fontFamily: 'primary',
      opacity: 0.5,
    },
    speakerUsername: {
      color: 'secondary',
      fontFamily: 'primary',
      opacity: 0.5,
    },
  },
  transcriptions: {
    square: {},
    portrait: {
      linesPerPage: 1,
    },
    landscape: {
      linesPerPage: 1,
    },
  },
}
